import { useRoutes } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import appTheme from "app/theme";
import "app/theme/vendor.css";
import routes from "app/routes";
import { TableCacheProvider } from "app/contexts/TableCacheContext";
import { ConfirmProvider } from "app/components/ui/dialogs";

const queryClient = new QueryClient();

export default function App() {
  const content = useRoutes(routes);

  return (
    <QueryClientProvider client={queryClient}>
      <TableCacheProvider>
        <ThemeProvider theme={appTheme}>
          <CssBaseline />
          <ConfirmProvider>
            {content}
            <ToastContainer position="top-right" autoClose={3500} newestOnTop closeOnClick pauseOnFocusLoss={false} />
          </ConfirmProvider>
        </ThemeProvider>
      </TableCacheProvider>
    </QueryClientProvider>
  );
}
